import { IUserPreferencesRepository } from '../../domain/repositories/IUserPreferencesRepository';
import { ThemeMode, UserPreferencesProps, LMSPreferences } from '../../domain/value-objects/UserPreferences';

export interface UpdateUserPreferencesRequest {
  userId: string;
  theme?: ThemeMode;
  lms?: Partial<LMSPreferences>;
}

export interface UpdateUserPreferencesResponse {
  preferences: UserPreferencesProps;
}

/**
 * Update User Preferences Use Case
 * Updates user preference settings in the database
 */
export class UpdateUserPreferencesUseCase {
  constructor(private readonly preferencesRepository: IUserPreferencesRepository) {}

  async execute(request: UpdateUserPreferencesRequest): Promise<UpdateUserPreferencesResponse> {
    // Get current preferences
    const currentPreferences = await this.preferencesRepository.getPreferences(request.userId);

    // Build updated preferences
    let updatedPreferences = currentPreferences;
    if (request.theme) {
      updatedPreferences = updatedPreferences.withTheme(request.theme);
    }
    if (request.lms) {
      updatedPreferences = updatedPreferences.withLMSPreferences(request.lms);
    }

    // Persist to database
    const savedPreferences = await this.preferencesRepository.updatePreferences(
      request.userId,
      updatedPreferences
    );

    return {
      preferences: savedPreferences.toJSON(),
    };
  }
}
